import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-solution.jpg";
import cons01 from "../../assets/img/solution1.jpg";
import cons02 from "../../assets/img/solution2.jpg";
import cons03 from "../../assets/img/solution3.jpg";
import cons04 from "../../assets/img/solution4.jpg";
import cons05 from "../../assets/img/solution5.jpg";
// import CallWipia from "./CallWipia";

function BusinessArea() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

    return (
        <>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
		
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>Solution</h2>
						<p>위피아는 새로운 기술과 솔루션 개발을 위해 지속적으로 연구와 개발을 진행하고 있습니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my bs-consulting-wrap solution-wrap">
					<ul className="consulting-list">
						{/* <!-- Item 01 --> */}
						<li>
							<img src={cons01} alt="인공지능(AI)" />

							<div className="textBox">
								<h4 className="title"><span className="num">01</span> 인공지능 (AI)</h4>
								<p className="sub-txt">AI 대변혁의 시대, 인공지능 전환(AX)과 생성 AI 기술을 결합한 서비스 단위의 솔루션을  제공 합니다.</p>
								<ul className="solution-list">
									<li>AI 에이전트 (Agent), 생성형 AI 챗봇</li>
									<li>AI 검색증강생성 (RAG) 애플리케이션</li>
									<li>AI 통합검색 , 벡터 검색 등 검색 포털</li>
									<li>NLP, LLM, SLM 애플리케이션</li>
									<li>AI Vision(영상분석, 이미지분석 등으로 객체인식, 위험상황 인식 등)</li>
									<li>멀티모달</li>
									<li>빅데이터 데이터 수집/분류/처리</li>
									<li>AI OCR, 업무 RPA( 업무 자동화 )</li>
								</ul>
							</div>
						</li>

						{/* <!-- Item 02 --> */}
						<li>

							<img src={cons02} alt="AIoT, Monitoring" />
							<div className="textBox">
								<h4 className="title"><span className="num">02</span> AIoT, Monitoring</h4>
								<p className="sub-txt">필요한 기술 컨설팅을 제공하며, 고객의 요구사항에 맞춰 AIoT 서비스를 구축하여 현장의 모든 상황에 대한 실시간 이벤트 모니터링 및 대응으로 맞춤 고객경험을 제공 합니다.</p>
								<ul className="solution-list">
									<li>IOT 장치 시스템 구축</li>
									<li>IOT 센서 기술 : 온도,습도, 압력 , 조도, 가속도, 자이로 센서,  GPS, GIS, ADAS, DTG, CCTV 등</li>
									<li>데이터 수집 및 전송기술 : 이더넷, RS232,RS485, Wi-FI, BLE, RFID/NFC, Zigbee, 4G/5G, NB-IOT, LoRa 등의 IOT Gateway</li>
									<li>맞춤형 IoT 애플리케이션 개발 : 공공, 생활, 안전, 복지, 물류/유통등의  문제 해결을 위한 AIoT 플랫폼 개발구축</li>
									<li>건설/시설물, 산업안전, 환경/재난/재해등 AIoT 서비스 개발 구축</li>
									<li>AIoT 데이터 학습/분석으로 상황인식, 행동예측 및 시각화 제공</li>
								</ul>
							</div>
						</li>

						{/* <!-- Item 03 --> */}
						<li>
							<img src={cons03} alt="위치기반서비스(Location Based Service, LBS) 개발 제공" />

							<div className="textBox">
								<h4 className="title"><span className="num">03</span> 위치기반서비스(Location Based Service, LBS) 개발 제공</h4>
								<p className="sub-txt">GIS,GPS, 휴대폰 위치를 이용하여 다양한 위치 기반 관제 서비스 솔루션을 제공합니다.</p>
								<ul className="solution-list">
									<li>위치기반 생활편의 앱 구축, 고객 맞춤형 서비스 구축</li>
									<li>긴급 구조요청 , 위험지역 경고등 안전 관련 모니터링 및 관제 서비스</li>
									<li>실시간 교통정보 , 모빌리티 위치 추적 및 관제 서비스,보험사 긴급출동 서비스</li>
									<li>물류 수배송 시스템 , 화물추적, FMS(차량관제 서비스), 콜드체인 물류관제 서비스</li>
									<li>탱크로리 관제, 고속/직행버스 관제, 셔틀버스 관제 , 스마트 가로등</li>
									<li>운전자 안전 위험상황 인지 서비스,  안심귀가 서비스, 개인 이동장치 신고 시스템 등</li>
								</ul>
							</div>
						</li>

						{/* <!-- Item 04 --> */}
						<li>
							<img src={cons04} alt="모바일 애플리케이션" />
							<div className="textBox">
								<h4 className="title"><span className="num">04</span> 모바일 애플리케이션 </h4>
								<p className="sub-txt">Web, Hybrid, native 등 다양한 플랫폼 환경을 제공합니다.</p>
								<ul className="solution-list">
									<li>크로스 플랫폼 앱 구축</li>
									<li>네이티브 앱 구축</li>
									<li>고객 맞춤형 특화 모바일 서비스 구축</li>
									<li>하이브리드 앱 구축</li>
								</ul>
							</div>
						</li>

						{/* <!-- Item 05 --> */}
						<li>
							<img src={cons05} alt="웹 시스템 개발제공" />
							<div className="textBox">
								<h4 className="title"><span className="num">05</span> 웹 시스템 개발제공 </h4>
								<p className="sub-txt">브랜드 가치와 사용자 경험을 중심으로 고객 맞춤형 비즈니스 및 서비스 플랫폼을 제공합니다.</p>
								<ul className="solution-list">
									<li>비즈니스 플랫폼 구축</li>
									<li>서비스 플랫폼 구축</li>
									<li>전자상거래 구축</li>
									<li>데이터 포털 구축</li>
									<li>반응형 웹사이트 구축</li>
									<li>콘텐츠 관리 시스템 구축</li>
								</ul>
							</div>
						</li>
					</ul>
			</section>

            {/* <CallWipia /> */}
		</main>
	<Footer />
        </>
    )
}

export default BusinessArea;